<script setup lang="ts">
import type { SelectProps } from "ant-design-vue";
import { onMounted, ref } from "vue";
import { type CommonPositionItem, fetchCommonPositionList } from "@/services/common";

const value = defineModel<Key>({ default: "" });

const positionList = ref<CommonPositionItem[]>([]);

const getPositionList = async () => {
	try {
		const res = await fetchCommonPositionList();

		positionList.value = res.data || [];
	} catch (_error) {
		// 错误处理
	}
};

const positionFilterOption: SelectProps["filterOption"] = (input, option) => {
	return (option?.position_name ?? "").toLowerCase().includes(input.toLowerCase());
};

onMounted(() => {
	getPositionList();
});
</script>

<template>
	<a-select
		v-bind="$attrs"
		v-model:value="value"
		show-search
		style="width: 100%"
		placeholder="请选择职位"
		allow-clear
		:options="positionList"
		:filter-option="positionFilterOption"
		:fieldNames="{ label: 'position_name', value: 'position_id' }"
	></a-select>
</template>
